import React, { useState, useEffect, useRef } from "react";
import {
  Center,
  ScrollView,
  Text,
  Image,
  HStack,
  Stack,
  Box,
  VStack,
  Pressable,
  Button,
  Modal,
} from "native-base";
import { LinearGradient } from "expo-linear-gradient";
import {  TouchableOpacity,Dimensions,Animated,ImageBackground } from "react-native";
import { GlobalStyles } from "./../constants/styles";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { GlobalConstants } from "../constants/constants";
import BusinessMainPage from "./main/BusinessMainPage";
import CitizenMainPage from "./main/CitizenMainPage";
import CityGovMainPage from "./main/CityGovMainPage";
import EventMainPage from "./main/EventMainPage";
import ChamberOfCommerceMainPage from "./main/ChamberOfCommerceMainPage";
import AdvertiserMainPage from "./main/AdvertiserMainPage";
import {
  MaterialIcons,
  Ionicons,
  FontAwesome5,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

function Home() {
  const navigation = useNavigation();

  let user = useSelector((state) => state.user.user);

  const [modalVisible, setModalVisible] = useState(false);

  const initialRef = useRef(null);

  const finalRef = useRef(null);
  

  const [currentIndex, setCurrentIndex] = useState(0);
  const features = [
  {
    id: 1,
    title: "City Updates",
    icon: (
      <Image
      source={require("../../assets/Home/cityUpdates.png")}
      alt="No hate speech"
      w={isMobile ? "40px" : "82px"}
      h={isMobile ? "40px" : "82px"}
      resizeMode="contain"
    />
    ),
    description:
      "Discover upcoming events, new services deals, and stay connected to local vibes.",
  },
  {
    id: 2,
    title: "Business Updates",
    icon: (
      <Image
      source={require("../../assets/Home/business.png")}
      alt="No hate speech"
      w={isMobile ? "40px" : "82px"}
      h={isMobile ? "40px" : "82px"}
      resizeMode="contain"
    />
    ),
    description:
      "Stay informed with new products and latest business news around the world.",
  },
  {
    id: 3,
    title: "City Government Updates",
    icon: (
      <Image
      source={require("../../assets/Home/cityGovUpdates.png")}
      alt="No hate speech"
      w={isMobile ? "40px" : "82px"}
      h={isMobile ? "40px" : "82px"}
      resizeMode="contain"
    />
    ),
    description:
      "Know about official city announcements, public notices, safety and more.",
  },
  {
    id: 4,
    title: "New & Trending Products",
    icon: (
      <Image
      source={require("../../assets/Home/trending.png")}
      alt="No hate speech"
      w={isMobile ? "40px" : "82px"}
      h={isMobile ? "40px" : "82px"}
      resizeMode="contain"
    />
    ),
    description:
      "Discover your favorite brands and explore the latest trending products.",
  },
];

const responsibleFeatures = [
  {
    id: 1,
    title: "No addictive business model",
    icon: (
      <Image
      source={require("../../assets/Home/addiction.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 2,
    title: "No fake content",
    icon: (
      <Image
      source={require("../../assets/Home/fake.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 3,
    title: "Safe for all ages",
    icon: (
      <Image
      source={require("../../assets/Home/safe.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 4,
    title: "No hate speech",
    icon: (
      <Image
      source={require("../../assets/Home/hate.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 5,
    title: "No targeted ads",
    icon: (
      <Image
      source={require("../../assets/Home/target.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
];
const InfoCard = ({ item, isMobile }) => {
  return (
    <VStack
      alignItems="center"
      space={3}
      px={4}
      py={5}
      w={isMobile ? "100%" : "70%"}
      alignSelf="center"
      space={12}
    >
      <HStack
        alignItems="center"
        justifyContent="center"
        space={6}
      >
        <Box>{item.icon}</Box>

        <Text
          fontSize={isMobile ? "22px" : "48px"}
          fontWeight="600"
          color="#22004B"
          textAlign="center"
          letterSpacing={-1.6}
          fontFamily={GlobalStyles.text.fontFamily}
        >
          {item.title}
        </Text>
      </HStack>

      <Text
        fontSize={isMobile ? "15px" : "20px"}
        color="#000000"
        textAlign="center"
        lineHeight={32}
        fontFamily={GlobalStyles.text.fontFamily}
      >
        {item.description}
      </Text>
    </VStack>
  );
};

const ResponsibleCard = ({ item, isMobile }) => {
  return (
    <VStack
      borderWidth={1}
      borderColor="#22004B"
      borderRadius="8px"
      px={3}
      py={4}
      mt={2}
      w={isMobile ? "135%" : "220px"}
      minH="230px"
      justifyContent="center"
      space={3}
      bg="#FFFFFF"
      
    >
      <Box
        w="80px"
        h="80px"
        borderRadius="full"
        bg="#22004B"
        position="absolute"
        top={6}
        alignItems="center"
        justifyContent="center"
      >
        {item.icon}
      </Box>
    <Box flex={1}
  justifyContent="center"
  alignItems="center"
  position="absolute"
  bottom={10}
  >
      <Text
        fontSize="25px"
        color="#22004B"
        fontWeight="300"
        lineHeight="34.8px"
        fontFamily={GlobalStyles.text.fontFamily}
      >
        {item.title}
      </Text>
    </Box>
    </VStack>
  );
};
const { width } = Dimensions.get("window");

  const isMobile = width < 768;

  // 🚀 Move to Next Item (Circular)
  const handlePrev = () => {
    const nextIndex = (currentIndex + 1) % carouselData.length; // Circular move
    setCurrentIndex(nextIndex);
    Animated.timing(translateX, {
      toValue: -nextIndex * (ITEM_WIDTH + ITEM_SPACING),
      duration: 500, // Smooth animation
      useNativeDriver: true,
    }).start();
  };

  useEffect(async () => {
    console.log(window?.innerHeight);
    if (user && user.is_new_user) {
      navigation.navigate("Settings");
    }
  }, []);

  return (
    <>
      {user && user.user_category == GlobalConstants.userCategories.guest.id ? (
        <CitizenMainPage />
      ) : user &&
        user.user_category == GlobalConstants.userCategories.citizen.id ? (
        <CitizenMainPage />
      ) : user &&
        user.user_category == GlobalConstants.userCategories.business.id ? (
        <BusinessMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.cityGovernment.id ? (
        <CityGovMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.chamberOfCommerce.id ? (
        <ChamberOfCommerceMainPage />
      ) : user &&
        user.user_category == GlobalConstants.userCategories.advertiser.id ? (
        <AdvertiserMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.eventOrganizer.id ? (
        <EventMainPage />
      ) : (
         <ScrollView
          flex={1}
          bg="#F4F1EF"
          showsVerticalScrollIndicator={false}
        >
          {/* ================= HERO SECTION ================= */}

          <LinearGradient
            colors={["#FFE69D", "#ffe16d", "#FFE289"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
              paddingTop: isMobile ? 30 : 50,
              paddingBottom: isMobile ? 50 : 90,
              paddingHorizontal: isMobile ? 20 : 40,
            }}
          >

            {/* HERO CONTENT */}
            <VStack alignItems="center" space={5}>
              <Text
                fontSize={isMobile ? "18px" : "42px"}
                fontWeight="800"
                color="#22004B"
                textAlign="center"
                fontFamily={GlobalStyles.text.fontFamily}
                lineHeight={isMobile ? 38 : 55}
                letterSpacing={-1.96}
              >
                Stay in Touch with City and Your Fav Business
              </Text>

              <Text
                w={isMobile ? "100%" : "65%"}
                textAlign="center"
                color="#4E336F"
                lineHeight={24}
                fontSize={isMobile ? "12px" : "15px"}
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Most social networks emphasize global, entertainment-focused
                content across many topics to keep users addictive.{"\n"}
                
                Local city information often slips by.{"\n"}
                
                TownTicks helps you discover and share local information with
                family and friends.
              </Text>

              <Pressable
                mt={3}
                bg="#22004B"
                px={8}
                py={3}
                borderRadius="5px"
                onPress={() => navigation.navigate("SignUp")}
              >
                <Text color="#fff" fontWeight="600">
                  Sign Up
                </Text>
              </Pressable>
            </VStack>
          </LinearGradient>

          {/* ================= WHITE INFO SECTION ================= */}

          <Box
            bg="#fff"
            borderTopRadius="40px"
            mt="-30px"
            pt={12}
            pb={14}
          >
            <VStack space={12}>
              {/* CITY IMAGE */}
              <Image
                source={require("../../assets/Home/pic-2.png")}
                alt="city"
                resizeMode="contain"
                alignSelf="center"
                w={isMobile ? "300px" : "440px"}
                h={isMobile ? "220px" : "270px"}
              />

              {/* FEATURES */}
              {features.map((item) => (
                <InfoCard
                  key={item.id}
                  item={item}
                  isMobile={isMobile}
                />
              ))}
            </VStack>
          </Box>

          {/* ================= RESPONSIBLE SOCIAL ================= */}

          <VStack
            px={isMobile ? 4 : 12}
            py={14}
            alignItems="center"
            space={5}
          >
            <HStack alignItems="center" space={2}>
              
                <Image
                  source={require("../../assets/Home/tt_logo.png")}
                  alt="No hate speech"
                  w={isMobile ? "80px" : "169px"}
                  h={isMobile ? "80px" : "169px"}
                  resizeMode="contain"
                />
              

              <Text
                fontSize={isMobile ? "22px" : "48px"}
                fontWeight="700"
                color="#3A1367"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                A Responsible Social Media
              </Text>
            </HStack>

            <Text
              textAlign="center"
              color="#777"
              lineHeight={24}
              fontSize={isMobile ? "12px" : "18px"}
              w={isMobile ? "100%" : "70%"}
              fontFamily={GlobalStyles.text.fontFamily}
            >
              Local city information helps us navigate everyday life. {"\n"}
              Social media like TownTicks helps to get
              that information and pass on to family and friends. {"\n"}
              Our responsible social media standards make
              sure to safe it for everyone.
            </Text>

            {/* RESPONSIBLE CARDS */}
            <HStack
              flexWrap="wrap"
              justifyContent="center"
              space={isMobile ? 2 : 4}
              mt={5}
            >
              {responsibleFeatures.map((item) => (
                <ResponsibleCard
                  key={item.id}
                  item={item}
                  isMobile={isMobile}
                />
              ))}
            </HStack>
          </VStack>

          {/* ================= FOOTER IMAGE ================= */}

          <Box mt={10}>
            <Image
              source={require("../../assets/Home/meetup.png")}
              alt="footer"
              w="100%"
              h={isMobile ? "380px" : "534px"}
              resizeMode="cover"
            />

            <HStack
              bg="#373737"
              px={6}
              py={4}
              justifyContent="space-between"
              alignItems="center"
            >
              <Text color="#fff" fontSize="12px" fontFamily={GlobalStyles.text.fontFamily}>
                TownTicks is associated to Novelma Inc.
              </Text>

              <Pressable onPress={() => setModalVisible(!modalVisible)}>
                <Text color="#fff" fontSize="12px" fontFamily={GlobalStyles.text.fontFamily}>
                  Contact Us
                </Text>
              </Pressable>
            </HStack>
          </Box>
        </ScrollView>
      )}

      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
      >
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Contact Us</Modal.Header>
          <Modal.Body>
            <Text>
              To contact or any feedback about TownTicks, write to
              <Text color={GlobalStyles.colors.blue}>
                {" "}
                support.townticks@novelma.com
              </Text>
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                Close
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Home;
